import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Stores scroll positions keyed by pathname
const scrollPositions = new Map<string, number>();

/**
 * Saves scroll position when leaving a page and restores it when returning.
 * Place this hook once in a layout component that wraps routed content.
 */
export function useScrollRestoration(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    // Restore saved scroll position for this path, or scroll to top
    const saved = scrollPositions.get(pathname);
    window.scrollTo(0, saved ?? 0);

    return () => {
      // Save current scroll position when leaving
      scrollPositions.set(pathname, window.scrollY);
    };
  }, [pathname]);
}
